/// <reference types="@types/googlemaps" />
import { Component, OnInit, ViewChild, ElementRef, NgZone, ApplicationRef, ContentChild } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {
  ServiceProviderCasePostPut, EServicePlace, AccountService, ServiceProviderCaseService,
  AccountRepairerService, ServiceProviderCaseCustomerUserProductSelect, ErrorTypeService, ErrorTypeListResponse
} from '../../../api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { CustomdatepickerComponent } from '../../../../shared/modules/customdatepicker.component';
import { Subject ,  Observable ,  of ,  concat } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-case',
  templateUrl: './case.component.html',
  styleUrls: ['./case.component.scss']
})
export class CaseComponent implements OnInit {
  @ViewChild('addr') public searchElement: ElementRef;
  @ContentChild(CustomdatepickerComponent) datepickerViewChild: CustomdatepickerComponent;

  caseForm: FormGroup;
  customers;
  defaultCustomers;
  customers$: Observable<ServiceProviderCaseCustomerUserProductSelect[]>;
  errorTypes: ErrorTypeListResponse[];
  user;
  fullname = '';
  selectedCustomer: any;
  products = [];
  shopList = [];
  repairers = [];
  customerAddress;
  repair;
  types = ['SupportingRequest'];
  case: ServiceProviderCasePostPut;
  bike;
  today = new Date();
  minDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
  filter = {
    page: 1,
    limit: 30,
    search: ''
  };
  init = true;
  isLoading = false;
  customerInput$ = new Subject<string>();
  constructor(
    public activeModal: NgbActiveModal,
    private cs: ServiceProviderCaseService,
    private errorTypeService: ErrorTypeService,
    private ars: AccountRepairerService,
    private app: ApplicationRef,
    private mapsAPILoader: MapsAPILoader, private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.getCustomer();
    this.ars.apiAccountRepairersSelectGet()
      .subscribe(data => {
        this.repairers = data;
      });
    if (this.user) {
      this.filter.search = this.fullname;
    }
    this.cs.apiServiceProviderCasesCustomerUserProductSelectGet(this.filter.page, this.filter.limit, this.filter.search)
      .subscribe(data => {
        this.customers = data;
        this.defaultCustomers = data;
        if (this.user) {
          this.customers.forEach(element => {
            if (element.customerId === this.user) {
              this.products = element.userProductSelects;
              if (this.products.length === 1) {
                this.bike = this.products[0].userProductId;
              }
              return;
            }
          });
        }
      });
      this.errorTypeService.apiErrorTypesGet(1)
      .subscribe(data => {
        this.errorTypes = data;
      });
    this.customerInput$.next('1');
    this.caseForm = new FormGroup({
      customer: new FormControl({ value: this.bike, disabled: false }, [
        Validators.required,
      ]),
      errorType: new FormControl(null, [
        Validators.required,
      ]),
      product: new FormControl(null, [
        Validators.required,
      ]),
      subject: new FormControl(null, [
        Validators.required,
        Validators.maxLength(32)
      ]),
      shop: new FormControl(null, [
        Validators.required,
      ]),
      repairer: new FormControl(this.repair, [
        Validators.required,
      ]),
      description: new FormControl(null, [
        Validators.required,
      ]),
      servicePlace: new FormControl('AtRepairshop'),
      address: new FormControl(this.customerAddress),
      date: new FormControl(),
      time: new FormControl(),
    });
    if (this.user) {
      this.caseForm.controls.customer.disable();
    }
    if (this.bike) {
      this.caseForm.controls.subject.disable();
    }
    this.servicePlace.valueChanges
      .subscribe(value => this.app.tick());
    this.customer.valueChanges
      .subscribe(value => console.log(value));
    this.mapsAPILoader.load().then(
      () => {
        const autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement, { types: ['address'] });
        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            const place: google.maps.places.PlaceResult = autocomplete.getPlace();
            this.address.patchValue(place.formatted_address);
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
          });
        });
      }
    );
    console.log(this.servicePlace.value)
  }

  get customer() { return this.caseForm.get('customer'); }
  get product() { return this.caseForm.get('product'); }
  get subject() { return this.caseForm.get('subject'); }
  get shop() { return this.caseForm.get('shop'); }
  get description() { return this.caseForm.get('description'); }
  get servicePlace() { return this.caseForm.get('servicePlace'); }
  get address() { return this.caseForm.get('address'); }
  get repairer() { return this.caseForm.get('repairer'); }
  get errorType() { return this.caseForm.get('errorType'); }
  get date() { return this.caseForm.get('date'); }
  get time() { return this.caseForm.get('time'); }

  getCustomer() {
    this.customers$ = concat(
      of([]),
      this.customerInput$.pipe(
        debounceTime(700),
        distinctUntilChanged(),
        switchMap(term => this.cs.apiServiceProviderCasesCustomerUserProductSelectGet(this.filter.page, this.filter.limit, term).pipe(
          catchError(() => of([])),
          tap(() => {
            // console.log(term);
            this.customers = [];
          })
        ))
      ));
  }
  onCloseCustomer() {
    this.customers = this.defaultCustomers;
  }
  selectCustomer(item) {

    var cus = null;
    if(typeof(item) == "object"){
      cus = item;
    }else{
      cus = this.customers.find(o => o.customerId == item);
    }
    this.bike = null;
    this.address.patchValue(cus.address);
    this.products = cus.userProductSelects;
  }
  changePlace(type) {
    if (type) {
      this.servicePlace.setValue('AtCustomerSite');
      this.caseForm.controls['shop'].clearValidators();
      this.caseForm.controls['address'].setValidators([Validators.required]);
      /* this.caseForm.controls['date'].setValidators([Validators.required]);
      this.caseForm.controls['time'].setValidators([Validators.required]); */
      this.shop.updateValueAndValidity();
      this.address.updateValueAndValidity();
      // this.date.updateValueAndValidity();
      // this.time.updateValueAndValidity();
    } else {
      this.servicePlace.setValue('AtRepairshop');
      this.caseForm.controls['address'].clearValidators();
      /* this.caseForm.controls['date'].clearValidators();
      this.caseForm.controls['time'].clearValidators(); */
      this.caseForm.controls['shop'].setValidators([Validators.required]);
      this.shop.updateValueAndValidity();
      this.address.updateValueAndValidity();
      // this.date.updateValueAndValidity();
      // this.time.updateValueAndValidity();
    }
  }
  validateForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      }
      this.app.tick();
    });
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  saveModal() {
    if (this.caseForm.valid) {
      this.case = {
        userProductId: this.product.value,
        subject: this.subject.value,
        description: this.description.value,
        repairshopId: this.shop.value,
        servicePlace: this.servicePlace.value,
        address: this.address.value,
        serviceTime: 0,
        repairerId: this.repairer.value,
        errorTypeId: this.errorType.value
      };
      if (this.servicePlace.value === 'AtCustomerSite' && (this.time.value || this.date.value)) {
        const date = new Date(this.date.value.year, this.date.value.month, this.date.value.day,
          this.time.value.hour, this.time.value.minute);
        this.case.serviceTime = Math.floor(date.getTime() / 1000);
      }
      if (!this.isLoading) {
        this.isLoading = true;
        this.cs.apiServiceProviderCasesPost(this.case).subscribe(
          data => {
            this.activeModal.close();
            this.isLoading = false;
          }, error => this.isLoading = false
        );
      }
    } else {
      this.validateForm(this.caseForm);
    }
  }
}
